// extracted by mini-css-extract-plugin
module.exports = {"section":"SwiperAni_section__e5d7d"};